import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Pricing from '../components/Pricing';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import WhyUs from '../components/WhyUs';
import Team from '../components/Team';
import Testimonials from '../components/Testimonials';

const Home = () => {
  return (
    <main>
      <Hero />
      <About />
      <Pricing />
      <Services />
      <HowItWorks />
      <WhyUs />
      <Team />
      <Testimonials />
    </main>
  );
};

export default Home;
